module.exports = __webpack_public_path__ + "img/71.45d3e193.jpg";